import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=8f6b782c&"
import script from "./LogoutIcon.vue?vue&type=script&lang=ts&"
export * from "./LogoutIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports